import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

function generateGuid() {
	function s4() {
		return Math.floor((1 + Math.random()) * 0x10000)
			.toString(16)
			.substring(1);
	}
	return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

export default function S3UploadPage() {
	const [file, setFile] = useState(null);
	const [loading, setLoading] = useState(false);
	const [link, setLink] = useState('');
	const [error, setError] = useState('');
	const [copied, setCopied] = useState(false);

	const onSelectFile = (e) => {
		setFile(e.target.files && e.target.files[0] ? e.target.files[0] : null);
		setLink('');
		setError('');
		setCopied(false);
	};

	const upload = () => {
		if (!file) return;
		setLoading(true);
		setLink('');
		setError('');

		try {
			const AWS = window.AWS;
			if (!AWS || !AWS.S3) {
				setError('AWS SDK chưa sẵn sàng trên trình duyệt.');
				setLoading(false);
				return;
			}

            var credentials = new AWS.Credentials("writeonlyuser", "awJBPnZwvVpGYmp5MDQsw3Ry7z5EsyAE");
			var ep = new AWS.Endpoint("https://data4.ikara.co:9000");
            var s3 = new AWS.S3({
                endpoint: ep,
                credentials: credentials,
                region: 'us-east-1',
                s3ForcePathStyle: true,
                httpOptions: {
                    timeout: 0 
                }
            });

			const fileExtension = (file.name.split('.').pop() || '').toLowerCase();
			const keyName = `${generateGuid()}${fileExtension ? '.' + fileExtension : ''}`;
			const bucketName = 'ikara-data/upload-files';
			let contentType = file.type || 'application/octet-stream';
			if (!file.type && fileExtension) {
				if (fileExtension === 'png') contentType = 'image/png';
				else if (fileExtension === 'jpg' || fileExtension === 'jpeg') contentType = 'image/jpeg';
				else if (fileExtension === 'gif') contentType = 'image/gif';
				else if (fileExtension === 'webp') contentType = 'image/webp';
				else if (fileExtension === 'mp3') contentType = 'audio/mpeg';
			}

			const reader = new FileReader();
			reader.onload = function () {
				const data = reader.result;
				const params = {
					ACL: 'public-read',
					ContentType: contentType,
					Bucket: bucketName,
					Key: keyName,
					Body: data
				};

				s3.putObject(params, function (err) {
					setLoading(false);
					if (err) {
						setError('Upload Failed: ' + (err.message || err));
						return;
					}
					const url = 'https://data4.ikara.co/data/minio/' + bucketName + '/' + keyName;
					setLink(url);
					setCopied(false);
				});
			};
			reader.readAsArrayBuffer(file);
		} catch (err) {
			setLoading(false);
			setError(err && err.message ? err.message : 'Upload error');
		}
	};

	const copyLink = async () => {
		if (!link) return;
		try {
			await navigator.clipboard.writeText(link);
			setCopied(true);
			setTimeout(() => setCopied(false), 2000);
		} catch (e) {
			setError('Không thể copy link.');
		}
	};

	return (
		<div className="container mt-5" style={{ maxWidth: 720 }}>
			<Helmet>
				<title>Upload File</title>
			</Helmet>
			<div className="card shadow-sm">
				<div className="card-body">
					<h5 className="card-title mb-3">Upload file lên S3</h5>
					<div className="mb-3">
						<input type="file" className="form-control" onChange={onSelectFile} />
						{file && (
							<small className="text-muted d-block mt-2">Đã chọn: {file.name}</small>
						)}
					</div>
					<div className="d-flex align-items-center">
						<button className="btn btn-primary" onClick={upload} disabled={!file || loading}>
							{loading ? 'Đang upload...' : 'Upload'}
						</button>
						{file && !loading && (
							<button className="btn btn-outline-secondary ml-2" onClick={() => { setFile(null); setLink(''); setError(''); setCopied(false); }}>Xóa chọn</button>
						)}
					</div>

					{error && (
						<div className="alert alert-danger mt-3" role="alert">{error}</div>
					)}

					{link && (
						<div className="mt-3">
							<label className="form-label">Link tải lên</label>
							<div className="input-group">
								<input type="text" className="form-control" value={link} readOnly />
								<button className="btn btn-outline-primary" type="button" onClick={copyLink}>{copied ? 'Đã copy' : 'Copy'}</button>
								<a className="btn btn-primary" href={link} target="_blank" rel="noreferrer">Mở link</a>
							</div>
							<small className="text-success d-block mt-2">Upload thành công!</small>
						</div>
					)}
				</div>
			</div>
		</div>
	);
}


